<template>
	<section id="agreement">
		<div class="container">
			<div class="agreement-logo">
				<img src="@/assets/img/logo-onoffice.png" alt="">
			</div>

			<div class="agreement-outer">
				<div class="agreement-inner">
					<p>{{ agreementText }}</p>
					<a :href="agreementLink">{{ agreementButtonText }}</a>
				</div>
			</div>
		</div>
	</section>
</template>

<script>

export default {
	props: {
		agreementLink: {
			type: String
		},
		agreementText: {
			type: String
		},
		agreementButtonText: {
			type: String
		},
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/agreementComponent.scss";
</style>
